<div class="di">
    <span>기다려주세요</span><br>
    <i class="fas fa-sync fa-spin"></i>
</div>
